/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "PdpRespSwatchSelector_user";
};
export type PdpRespSwatchSelector_user$data = PdpRespSwatchSelector_user;
export type PdpRespSwatchSelector_user$key = {
    readonly " $data"?: PdpRespSwatchSelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0f1bcdc92d1d6e0fd182d5f7f33b5845';
export default node;
